import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ProgrammeDetail() {
    const { slug } = useParams();
    const [p, setP] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        api.get(`/programmes/${slug}`)
            .then((r) => setP(r.data))
            .catch(() => setNotFound(true));
    }, [slug]);

    if (notFound) return <div className="container-hero py-32"><h1 className="font-display text-4xl">Programme not found</h1><Link to="/programmes" className="text-brand-forest mt-4 inline-block">← Back to programmes</Link></div>;
    if (!p) return <div className="container-hero py-32 text-slate-500">Loading…</div>;

    return (
        <div data-testid="programme-detail">
            <section className="pt-16 md:pt-24">
                <div className="container-hero">
                    <Link to="/programmes" className="inline-flex items-center gap-2 text-sm text-brand-forest font-semibold mb-8"><ArrowLeft size={16} /> All programmes</Link>
                    <div className="grid md:grid-cols-12 gap-10">
                        <div className="md:col-span-7">
                            <div className="label-eyebrow text-brand-forest mb-4">{p.tagline}</div>
                            <h1 className="font-display text-5xl sm:text-6xl font-semibold leading-[1.05]">{p.title}</h1>
                            <div className="prose max-w-none mt-8 text-slate-700 text-lg leading-relaxed whitespace-pre-line">
                                {p.description || p.summary}
                            </div>
                            {p.outcomes?.length > 0 && (
                                <div className="mt-10">
                                    <div className="label-eyebrow text-brand-forest mb-3">Outcomes</div>
                                    <ul className="space-y-2">
                                        {p.outcomes.map((o) => (
                                            <li key={o} className="flex items-start gap-2 text-slate-700"><CheckCircle2 size={18} className="text-brand-forest mt-0.5 flex-shrink-0" strokeWidth={1.5} /> {o}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className="md:col-span-5">
                            {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full aspect-[4/5] object-cover rounded-2xl sticky top-24" />}
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-24 mt-16 bg-brand-forest text-white">
                <div className="container-hero text-center">
                    <h2 className="font-display text-4xl sm:text-5xl font-medium max-w-2xl mx-auto leading-tight">Support this programme.</h2>
                    <p className="text-white/80 mt-3 max-w-lg mx-auto">Every contribution goes directly to the field.</p>
                    <div className="mt-8 flex flex-wrap justify-center gap-3">
                        <Link to="/donate" className="px-7 py-3.5 rounded-full bg-white text-brand-ink font-semibold hover:bg-brand-ochre hover:text-white transition-colors duration-200">Donate</Link>
                        <Link to="/contact" className="px-7 py-3.5 rounded-full border border-white/70 text-white hover:bg-white/10 transition-colors duration-200">Volunteer</Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
